import { render } from "./Media.vue?vue&type=template&id=19d662fc"
import script from "./Media.vue?vue&type=script&lang=ts"
export * from "./Media.vue?vue&type=script&lang=ts"
script.render = render

export default script